import React from "react";
import { Link } from "react-router";
import PublicPage from "./public-page";

const NotFound = () => (
  <PublicPage>
    <div className="content text-center align-items-center">
      <h3>Not found!</h3>
    </div>
    <div className="footer text-center mt-5">
      <Link className="text-uppercase" to="/">
        Login
      </Link>
    </div>
  </PublicPage>
);

export default NotFound;
